/**
 * Scrolls to the given element if it is not in the viewport.
 *
 * @param element - element to scroll to
 */
const scrollToElement = (element: HTMLDivElement) => {
    const isInViewport = (elem: HTMLDivElement) => {
        const rect = elem.getBoundingClientRect();
        return rect.top <= (window.innerHeight || document.documentElement.clientHeight) && rect.bottom >= 0;
    };

    if (element && !isInViewport(element)) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
};

export default scrollToElement;
